import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./Login.css";

const Login = () => {
  let navigate = useNavigate();
  const [credentials, setCredentials] = useState({
    email: "",
    password: "",
  });

  const handleSubmit = async (event) => {
    event.preventDefault();
    const response = await fetch("https://hungryhub-backend.vercel.app/api/loginuser", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email: credentials.email,
        password: credentials.password,
      }),
    });
    const data = await response.json();

    if (!data.success) {
      alert("Enter Valid Details");
      return;
    }
    localStorage.setItem("userEmail", credentials.email);
    localStorage.setItem("authToken", data.authToken);
    navigate("/");
  };

  const onChangeHandler = (event) => {
    setCredentials({
      ...credentials,
      [event.target.name]: event.target.value,
    });
  };

  return (
    <div className="login">
      <div className="container">
        <form className="login-form" onSubmit={handleSubmit}>
          <h1 className="login-header">Login</h1>
          <input
            type="email"
            className="input-field"
            placeholder="Email Address"
            value={credentials.email}
            name="email"
            required
            onChange={onChangeHandler}
          />
          <input
            type="password"
            className="input-field"
            placeholder="Password"
            value={credentials.password}
            name="password"
            required
            onChange={onChangeHandler}
          />
          <button type="submit" className="login-button">
            Log In
          </button>
          <Link to="/signup" className="signup-redirect-link">
            Don't have an account? Sign Up
          </Link>
        </form>
      </div>
    </div>
  );
};

export default Login;
